const $ = window.jQuery;

const KomplettaSystem = {
	init() {
		const $module = $('.wp-komplett-system');

		if (!$module.length) return;

		const toggleBtn = $module.find('.toggle-system-info a');

		toggleBtn.on('click', function (e) {
			e.preventDefault();
			if ($(this).attr('data-orgtext') === undefined) {
				$(this).attr('data-orgtext', $(this).text());
			}

			const parentContainer = $(this).closest('.wp-komplett-system');
					parentContainer.find('.kompletta-system-content').slideToggle('fast');

			$(this).toggleClass('active');
			if ($(this).hasClass('active')) {
				$(this).text('Stäng ');
			} else {
				$(this).text($(this).attr('data-orgtext'));
			}
		});
	},
};

export default KomplettaSystem;
